import { useState } from "react";
import { toast } from "sonner";
import { AgentService } from "@/services/agent/agent.service";

export const useAgentRunMutations = () => {
  const [isCancelling, setIsCancelling] = useState(false);

  const cancelAgent = async (agentRunId: string) => {
    setIsCancelling(true);
    try {
      await AgentService.cancelAgent({ agent_run_id: agentRunId });
      toast.success("エージェント実行をキャンセルしました");
    } catch (error) {
      console.error("Failed to cancel agent:", error);
      toast.error("キャンセルに失敗しました。もう一度お試しください");
      throw error;
    } finally {
      setIsCancelling(false);
    }
  };

  return {
    cancelAgent,
    isCancelling,
  };
};
